import { render } from "./reminder-modal.vue?vue&type=template&id=1ebbf042"
import script from "./reminder-modal.vue?vue&type=script&lang=js"
export * from "./reminder-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__